import NewspaperIcon from "@mui/icons-material/Newspaper";
import React from "react";

const RecordingClassOrder = [
  [
    "Order Recording Courses",
    "/admin/order-recording-class", 
    <NewspaperIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></NewspaperIcon>,
  ],
];

export default RecordingClassOrder;
